import React, { Component } from "react";
import ComponentHeader from "./ComponentHeader";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { StandardBarChart } from "../../Common/Charts/StandardBarChart";
import ComponentActions from "./ComponentActions";

class BarChartComponent extends Component {
  render() {
    const {
      slideId,
      isPreparePresentation,
      isComposition,
      isPresentation,
      hasComments,
      indicatorsExplanation,
      hasExplanation,
      component: {
        componentId,
        labels,
        data,
        config: {
          NoComponentHeader,
          ConfigComponentHeight,
          annexeAttachmentCategory
        }
      },
      layoutProps: { containerHeight }
    } = this.props;
    return (
      <div>
        {NoComponentHeader ? null : (
          <ComponentHeader
            slideId={slideId}
            percentage={false}
            title={labels}
            annexeAttachmentCategory={annexeAttachmentCategory}
            handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
            isComposition={isComposition}
            isPresentation={isPresentation}
            hasComments={hasComments}
            componentId={componentId}
            isPreparePresentation={isPreparePresentation}
            indicatorsExplanation={indicatorsExplanation}
            hasExplanation={hasExplanation}
            inSlideView={this.props.inSlideView}
          />
        )}

        <div
          className={classnames(
            styles.LineChartComponent,
            styles.flex_container
            // styles.align_container
          )}
        >
          {!this.props.inSlideView && (
            <ComponentActions
              removeComponent={this.props.handleRemoveComponent}
              updateComponent={this.props.handleUpdateComponent}
              componentCase={this.props.ComponentCase}
              sideBar={"MultiIndicatorComponentConfig"}
              component={"BarChartComponent.png"}
            />
          )}
          <span
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.align_container
            )}
            style={containerHeight ? { alignItems: "baseLine" } : null}
          >
            <StandardBarChart
              chartData={Object.values(data.data)}
              dataKeysY={data.accounts.map(({ code }) => code)}
              dataKeyX={"year"}
              currency={data.accounts[0].unit === "€"}
              legendLabels={data.accounts.map(({ label }) => label)}
              // containerWidth={"xxx%"}
              containerHeight={
                ConfigComponentHeight ? ConfigComponentHeight : containerHeight
              }
            />
          </span>
        </div>
      </div>
    );
  }
}

export default BarChartComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/BarChartComponent.js